import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverlayLoaderService {
  private isLoading$ = new BehaviorSubject<boolean>(false);

  private _isGlobalLoader = true;

  private _ignoreChanges = false;

  get changes() {
    return this.isLoading$.asObservable();
  }

  get isGlobalLoader() {
    return this._isGlobalLoader;
  }

  set isGlobalLoader(value: boolean) {
    this._isGlobalLoader = value;
  }

  public set isLoading(value) {
    if (!this._ignoreChanges) {
      this.isLoading$.next(value);
    }
  }

  public get isLoading() {
    return this.isLoading$.value;
  }

  public set ignoreChanges(value: boolean) {
    this._ignoreChanges = value;
  }

  public setLoadingToFalse(): void {
    this.ignoreChanges = false;
    this.isGlobalLoader = false;
    this.isLoading$.next(false);
  }
}
